import UtilityProgramEnrollmentManager from '@/app/features/utility-programs/UtilityProgramEnrollmentManager/UtilityProgramEnrollmentManager'
import UtilityProgramLegacyLearnMoreCard from '@/app/features/utility-programs/UtilityProgramLearnMoreDashboardView/UtilityProgramLegacyLearnMoreCard'
import useThermostatDeviceSectionViewModel from '../useThermostatDeviceSectionViewModel'
import { ProgramDisplay } from '@/hooks/useMultiProgramDisplay/useProgramDisplayType'
import { Card, Grid, GridItem, Text, Toggle } from '@/components'
import DeviceProgramCards from '@/app/components/ProgramCards/DeviceProgramCards'
import MenuCard from '@/components/MenuCard'

export default function ThermostatProgramsTab({
  gridSupportToggle,
  thermostatId,
  programDisplayType,
}: ReturnType<typeof useThermostatDeviceSectionViewModel>) {
  return (
    <div className="flex flex-col w-full gap-4">
      {programDisplayType === ProgramDisplay.Legacy && (
        <>
          <UtilityProgramLegacyLearnMoreCard />
          <UtilityProgramEnrollmentManager
            deviceType="thermostat"
            deviceId={thermostatId}
            wrapper={Card}
          />
        </>
      )}
      {programDisplayType === ProgramDisplay.MultiProgram && (
        <DeviceProgramCards />
      )}
      <MenuCard icon="Zap" iconColor="#FBD242" title="Be a Watt Hero">
        <Grid flow="column">
          <GridItem>
            <Text variant="subheader">Support Your Local Grid</Text>
            <Text variant="body2">
              Automatically apply for programs where shifting my thermostat
              would support the local grid.
            </Text>
          </GridItem>
          <GridItem className="pl-16 pt-2">
            <Toggle
              id="thermostat-grid-support-toggle"
              checked={gridSupportToggle.isToggleOn}
              onChange={gridSupportToggle.onToggleChange}
            />
          </GridItem>
        </Grid>
      </MenuCard>
    </div>
  )
}
